import { MetaData } from './metadata';
import { Brand } from './brand';

export class BrandDto {
  constructor(public metadata: MetaData, public results: Brand[]) {}
}
